import React from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileBottomBar from './MobileBottomBar';

const Layout = ({ children }) => {
    return (
        <div className="flex min-h-screen flex-col">
            <Header />
            <main className="flex-1 pb-20 md:pb-0">
                {children}
            </main>
            <Footer />
            <MobileBottomBar />
        </div>
    );
};

export default Layout;
